// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { GRTabbarIconSvg } from '../assets/svg';

const Wrapper = styled.div`
  width: 2em;
  height: 2em;
  margin: 0;
  padding: 0;

  position: relative;
  overflow: hidden;
`;

const Icon = styled(GRTabbarIconSvg)`
  width: 100%;
  height: 100%;

  ${({ $isHighlight }) => css`
    & .gr-tabbar-icon-hat {
      transform-origin: left center;
      transition: transform 500ms ease-in-out;

      ${$isHighlight
        ? css`
            transform: rotateZ(-20deg) translate(-10%, 5%);
          `
        : undefined}
    }

    & .gr-tabbar-icon-sparkles {
      filter: drop-shadow(0em 0em 1em white);
    }

    & .gr-tabbar-icon-sparkle {
      transition: stroke-dashoffset 200ms ease-in-out;
      stroke-dasharray: 3;
      stroke-dashoffset: 3;

      ${$isHighlight
        ? css`
            stroke-dashoffset: 0;
          `
        : undefined};
    }
  `}
`;

type GRIconProps = {
  isHighlight?: boolean;
  className?: string;
};

const GRIcon = ({ className = '', isHighlight = false }: GRIconProps) => {
  return (
    <Wrapper className={className}>
      <Icon $isHighlight={isHighlight} />
    </Wrapper>
  );
};

export default GRIcon;
